const DEBOUNCE_MS = 250;

function initPropertiesFilter() {
  const filter = document.querySelector(".properties-filter");

  if (!filter) {
    return;
  }

  const form = filter.querySelector(".properties-filter__form");
  const submitButton = filter.querySelector(".properties-filter__submit");
  const submitText = filter.querySelector(".properties-filter__submit-text");
  const countUrl = form?.dataset.countUrl;

  if (!form || !submitButton || !submitText || !countUrl) {
    return;
  }

  const controls = form.querySelectorAll(".properties-filter__control");
  let debounceId = null;
  let abortController = null;

  function getCountParams() {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (typeof value === "string" && value !== "") {
        params.set(key, value);
      }
    }

    return params;
  }

  function setSubmitCount(count, label) {
    if (typeof label === "string") {
      submitText.textContent = label;
    }

    submitButton.disabled = count === 0;
  }

  async function updateCount() {
    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();
    submitButton.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(
        `${countUrl}?${getCountParams().toString()}`,
        {
          signal: abortController.signal,
        },
      );

      if (!response.ok) {
        return;
      }

      const data = await response.json();

      if (typeof data.count === "number") {
        setSubmitCount(data.count, data.label);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        throw error;
      }
    } finally {
      submitButton.removeAttribute("aria-busy");
    }
  }

  function scheduleCountUpdate() {
    window.clearTimeout(debounceId);
    debounceId = window.setTimeout(updateCount, DEBOUNCE_MS);
  }

  controls.forEach((control) => {
    control.addEventListener("change", scheduleCountUpdate);
  });
}

initPropertiesFilter();
